type IconProps = {
	width?: number;
	height?: number;
	maskColor?: string;
	color?: string;
}

export const RCFullLoadIcon = (props: IconProps) => {
	const {
		width = 19,
		height = 18,
		maskColor = '#D9D9D9',
		color = '#010A26'
	} = props;
	return (
		<svg role={'img'} width={width} height={height} viewBox='0 0 19 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<mask id='mask0_1418_31559' style={{ maskType: 'alpha' }} maskUnits='userSpaceOnUse' x='0' y='0' width='25' height='24'>
				<rect x='0.199951' width='24' height='24' fill={maskColor} />
			</mask>
			<g mask='url(#mask0_1418_31559)'>
				<path d='M4.69995 15C4.07495 15 3.5437 14.7812 3.1062 14.3438C2.6687 13.9062 2.44995 13.375 2.44995 12.75H0.949951V4.5C0.949951 4.0875 1.09683 3.73438 1.39058 3.44063C1.68433 3.14688 2.03745 3 2.44995 3H12.95V6H15.2L17.45 9V12.75H15.95C15.95 13.375 15.7312 13.9062 15.2937 14.3438C14.8562 14.7812 14.325 15 13.7 15C13.075 15 12.5437 14.7812 12.1062 14.3438C11.6687 13.9062 11.45 13.375 11.45 12.75H6.94995C6.94995 13.375 6.7312 13.9062 6.2937 14.3438C5.8562 14.7812 5.32495 15 4.69995 15ZM4.69995 13.5C4.91245 13.5 5.09058 13.4281 5.23433 13.2844C5.37808 13.1406 5.44995 12.9625 5.44995 12.75C5.44995 12.5375 5.37808 12.3594 5.23433 12.2156C5.09058 12.0719 4.91245 12 4.69995 12C4.48745 12 4.30933 12.0719 4.16558 12.2156C4.02183 12.3594 3.94995 12.5375 3.94995 12.75C3.94995 12.9625 4.02183 13.1406 4.16558 13.2844C4.30933 13.4281 4.48745 13.5 4.69995 13.5ZM2.44995 11.25H3.04995C3.26245 11.025 3.5062 10.8438 3.7812 10.7063C4.0562 10.5688 4.36245 10.5 4.69995 10.5C5.03745 10.5 5.3437 10.5688 5.6187 10.7063C5.8937 10.8438 6.13745 11.025 6.34995 11.25H11.45V4.5H2.44995V11.25ZM13.7 13.5C13.9125 13.5 14.0906 13.4281 14.2343 13.2844C14.3781 13.1406 14.45 12.9625 14.45 12.75C14.45 12.5375 14.3781 12.3594 14.2343 12.2156C14.0906 12.0719 13.9125 12 13.7 12C13.4875 12 13.3093 12.0719 13.1656 12.2156C13.0218 12.3594 12.95 12.5375 12.95 12.75C12.95 12.9625 13.0218 13.1406 13.1656 13.2844C13.3093 13.4281 13.4875 13.5 13.7 13.5ZM12.95 9.75H16.1375L14.45 7.5H12.95V9.75Z' fill={color} />
			</g>
		</svg>
	);
};
